var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{attrs:{"data-testid":"tree-popup-tree-iVxst9","value":_vm.show,"height":"80%","title":_vm.title,"position":"bottom"},on:{"cancel":_vm.handleCancel,"confirm":_vm.handleConfirm}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }